import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { ChevronRightIcon } from '@heroicons/react/20/solid'
import { Oval } from 'react-loader-spinner';

const VerificationCodeEntry = () => {
  const [username, setUsername] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [verificationError, setVerificationError] = useState('');
  const [succ, setSucc] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isResending, setIsResending] = useState(false);


  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  const handleVerification = async () => {
    if (isVerifying) return; // Prevent multiple simultaneous verifications
    setIsVerifying(true);
    try {
      if (!/^\d{6}$/.test(verificationCode)) {
        setVerificationError('Verification code must be a 6-digit number');
        return;
      }
      
      // console.log("email in verification is ", username);
      await Auth.confirmSignUp(username, verificationCode);
      setSucc(true);
    } catch (error) {
      setVerificationError(error.message);
    } finally {
      setIsVerifying(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleVerification();
    }
  };

 const resendVerificationCode = async () => {
    if (isResending) return; // Prevent multiple simultaneous resend requests
    setIsResending(true);
    try {
      await Auth.resendSignUp(username);
      // console.log('Verification code resent successfully');
      setVerificationError("Successfully resent verification code");
    } catch (error) {
      console.error('Error resending verification code:', error);
      setVerificationError(error.message);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="px-4 xs:px-6 sm:px-8">
      <div className="border-1 border-border-light p-3 xs:p-4 sm:p-6 rounded-lg w-full max-w-xs xs:max-w-sm sm:max-w-md md:max-w-lg mx-auto my-5 font-sans border-b border-primary-500">
        {succ ? (
          <div className="flex flex-col items-center text-center">
            <h2 className="text-lg xs:text-xl sm:text-2xl mb-2 xs:mb-3">You have successfully made an account!</h2>
            <h3 className="text-base xs:text-lg sm:text-xl mb-4 xs:mb-6">The next step is to log in.</h3>
            <a href="./signin" className="no-underline w-full">
              <button className="bg-primary-500 hover:bg-primary-600 text-white px-4 xs:px-6 py-2 xs:py-3 border-0 rounded-md cursor-pointer my-2.5 mx-auto block shadow-md w-full max-w-xs xs:max-w-sm sm:max-w-md flex justify-center items-center text-sm xs:text-base">
                Log in
              </button>
            </a>
          </div>
        ) : (
          <div>
            <h1 className="font-sans text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold capitalize pb-2 xs:pb-3 sm:pb-4">
              Email Verification
            </h1>
            <p className="text-sm xs:text-base sm:text-lg mb-4 xs:mb-6">
              Enter the verification code sent to your email.
            </p>
           
            <div className="flex flex-col items-center w-full pt-2">
              <input
                type="text"
                placeholder="Email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="p-2 xs:p-3 border border-neutral-300 rounded-md text-sm xs:text-base w-full max-w-xs xs:max-w-sm sm:max-w-md mb-2.5 bg-white text-black"
              />
              <input
                type="text"
                placeholder="Verification Code"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                onKeyPress={handleKeyPress}
                className="p-2 xs:p-3 border border-neutral-300 rounded-md text-sm xs:text-base w-full max-w-xs xs:max-w-sm sm:max-w-md mb-2.5 bg-white text-black"
              />
              <button
                onClick={handleVerification}
                className={`
                  bg-primary-500 hover:bg-primary-600 text-white px-4 xs:px-6 py-2 xs:py-3 border-0 rounded-md cursor-pointer my-2.5 shadow-md w-full max-w-xs xs:max-w-sm sm:max-w-md flex justify-center items-center transition-colors duration-200 text-sm xs:text-base
                  ${isVerifying ? 'opacity-70 cursor-not-allowed hover:bg-primary-500' : ''}
                `}
                disabled={isVerifying}
              >
                {isVerifying ? (
                  <>
                    <Oval color="#fff" height={16} width={16} className="xs:h-5 xs:w-5" />
                    <span className="ml-2 xs:ml-2.5">Verifying...</span>
                  </>
                ) : (
                  'Verify'
                )}
              </button>
            </div>
   
            <div className="text-left px-2 xs:px-4 my-2.5">
              <p onClick={toggleExpand} className="cursor-pointer flex items-center text-sm xs:text-base">
                <ChevronRightIcon
                  className={`${!expanded ? '' : 'rotate-90 transform'} h-4 w-4 xs:h-5 xs:w-5 text-neutral-500 mr-1`}
                />
                I didn't receive a verification code.
              </p>
              {expanded && (
                <ul className="text-left text-xs xs:text-sm sm:text-base mt-2 xs:mt-3 space-y-1 xs:space-y-2">
                  <li>If you did not receive a verification code, please check your spam folder.</li>
                  <li>
                    <p className="leading-relaxed">
                      To get a new code, enter your email in the "Email" section above then click
                      <button
                        onClick={resendVerificationCode}
                        className={`
                          no-underline text-primary-500 font-bold bg-transparent border-0 px-1 inline-flex items-center hover:text-primary-600 transition-colors duration-200 text-xs xs:text-sm sm:text-base
                          ${isResending ? 'cursor-not-allowed' : 'cursor-pointer'}
                        `}
                        disabled={isResending}
                      >
                        {isResending ? (
                          <Oval color="#3b82f6" height={12} width={12} className="xs:h-4 xs:w-4" />
                        ) : (
                          'here'
                        )}
                      </button>
                      to receive the code.
                    </p>
                  </li>
                </ul>
              )}
            </div>
   
            {verificationError && (
              <p className="text-error-500 text-xs xs:text-sm sm:text-base mt-2 xs:mt-3 px-2 xs:px-4">
                {verificationError}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};


export default VerificationCodeEntry;
